import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-900" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-0 py-1.5 px-4 bg-brand-primary rounded-full text-xs font-semibold tracking-wide text-brand-button-text transform -translate-y-1/2"
}
const _hoisted_4 = { class: "mt-0 lg:mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2 uppercase font-extrabold tracking-wide text-xs"
}
const _hoisted_6 = { class: "flex items-end text-gray-900" }
const _hoisted_7 = { class: "leading-7" }
const _hoisted_8 = {
  key: 0,
  class: "mb-1 tracking-tight font-extrabold text-4xl"
}
const _hoisted_9 = {
  key: 1,
  class: "my-4 lg:my-6 text-gray-500"
}
const _hoisted_10 = { class: "font-extrabold text-gray-500" }
const _hoisted_11 = {
  key: 2,
  class: "my-4 lg:my-6 text-gray-500"
}
const _hoisted_12 = {
  role: "list",
  class: "mt-6 mb-6 space-y-6 hidden lg:block"
}
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "ml-3 text-gray-500" }
const _hoisted_15 = { class: "ml-3 text-gray-500" }
const _hoisted_16 = ["href"]

import { CheckIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import { BrandServiceInterface, PlanSelectorProductInformation } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number,
  discountedPrice?: number,
  discounted?: boolean,
  displayDiscount?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanSelectorProduct',
  props: {
    canSelectProduct: { type: Boolean },
    isSelectedProduct: { type: Boolean },
    product: {},
    planSelectorProductInformation: {}
  },
  emits: ["onPlanSelected"],
  setup(__props: any, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

const emit = __emit;

const mostPopular = computed(() => {
  return props.product.download === 250
    ? 'text-white hover:bg-brand-primary'
    : 'text-brand-secondary hover:bg-brand-primary';
});

const standardFeatures = ref(props.planSelectorProductInformation.standardFeatures).value;
const standardLinks = ref(props.planSelectorProductInformation.standardLinks).value;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPlanSelected', _ctx.product.id))),
    class: _normalizeClass(["my-2 lg:my-0 transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col lg:w-1/4", { 'border-black border': _ctx.isSelectedProduct, 'border border-gray-200': !_ctx.isSelectedProduct, 'cursor-pointer': _ctx.canSelectProduct }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.product.name), 1),
      (_ctx.product.download === 250)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Most Popular!"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.product.id && !_unref(brandService).removeDefaultPlansFrom())
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "From"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              class: _normalizeClass(['tracking-tight font-extrabold', _ctx.product.displayDiscount ? 'text-2xl text-gray-300 text-decoration-line: line-through' : 'text-4xl font-extrabold'])
            }, "$" + _toDisplayString(_ctx.product.price), 3),
            (_ctx.product.displayDiscount)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "$" + _toDisplayString(_ctx.product.discountedPrice), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-1 text-xl font-semibold" }, "/Month", -1))
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, [
        _createElementVNode("span", { class: "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-brand-primary text-brand-button-text" }, "Unlimited Data!")
      ], -1)),
      (_ctx.product.typicalEveningSpeed)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.product.typicalEveningSpeed) + " Mbps", 1),
            _cache[2] || (_cache[2] = _createTextVNode(" typical evening speed"))
          ]))
        : _createCommentVNode("", true),
      (_ctx.product.download ? _ctx.product.download > 100 : false)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Average sampled evening speed not currently available"))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_12, [
        _createElementVNode("li", _hoisted_13, [
          _createVNode(_unref(CheckIcon), {
            class: "flex-shrink-0 w-6 h-6 text-brand-secondary-accent",
            "aria-hidden": "true"
          }),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.product.description), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardFeatures), (standardFeature) => {
          return (_openBlock(), _createElementBlock("li", {
            key: standardFeature,
            class: "flex"
          }, [
            _createVNode(_unref(CheckIcon), {
              class: "flex-shrink-0 w-6 h-6 text-brand-secondary-accent",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_15, _toDisplayString(standardFeature), 1)
          ]))
        }), 128))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardLinks), (standardLink) => {
        return (_openBlock(), _createElementBlock("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href text-blue-500 hover:text-blue-800 hover:underline transition duration-250 my-3"
        }, _toDisplayString(standardLink.name), 9, _hoisted_16))
      }), 128))
    ]),
    (_ctx.canSelectProduct)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["transition duration-250", [mostPopular.value, 'mt-0 lg:mt-8 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium text-brand-button-text', _ctx.isSelectedProduct ? 'bg-brand-button' : 'bg-brand-primary-light']])
        }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Plan'), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})